import useIsWiderThan from '@/hooks/useIsWiderThan';
/**
 * React Hook that returns the how many search columns to show
 * based on the window size
 *
 * @returns number - indicating how many categories to show
 * This is important to get the right number of promoted items.
 */

type Props = {
    isOnSearchPage?: boolean;
};

const useGetSearchColumns = ({ isOnSearchPage = false }: Props = {}) => {
    const widerThan1239 = useIsWiderThan(1239); // 3 columns
    const widerThan933 = useIsWiderThan(933); // 2 columns
    const widerThan768 = useIsWiderThan(768); // 1 columns
    const widerThan739 = useIsWiderThan(739); // 4 columns
    const widerThan560 = useIsWiderThan(560); // 3 columns
    const widerThan381 = useIsWiderThan(381); // 2 columns

    if (isOnSearchPage) {
        if (widerThan1239) {
            return 4;
        } else if (widerThan768) {
            return 3;
        }
        return 2;
    }

    if (widerThan1239) {
        return 3;
    } else if (widerThan933) {
        return 2;
    } else if (widerThan768) {
        return 1;
    } else if (widerThan739) {
        return 4;
    } else if (widerThan560) {
        return 3;
    } else if (widerThan381) {
        return 2;
    }

    return 1;
};

export default useGetSearchColumns;
